import React from 'react';
import Button from '../../../component/ui/Button';
import Modal from '../../../component/modal/Modal';
import { hasPermission } from '../../../utils/controller';

export default function AutoSaveModal({
	isOpenModel,
	setIsOpenModel,
	user,
	type,
	withoutSave,
	saveAsDraft = null,
	SaveAsContinue,
	permission,
}) {
	return (
		<Modal
			className="deleteVendorsModal"
			title={`${type} Auto Save`}
			isOpen={isOpenModel}
			onClose={() => {
				setIsOpenModel(false);
			}}
			cancelButton={() => {
				setIsOpenModel(false);
			}}
		>
			<div className="auto-save-description">
				{'You have unsaved changes. Do you want to continue without saving?'}
			</div>

			<div className="d-flex justify-content-end align-items-center gap-4">
				<Button
					type="button"
					button="Leave Without Saving"
					className="mt-0 px-4 btn-danger relative"
					onClick={() => withoutSave()}
				/>
				{saveAsDraft && (
					<Button
						type="button"
						button="Save As Draft"
						disabled={!hasPermission(permission, user?.role?.role_permissions)}
						className="mt-0 px-4 btn-primary relative"
						onClick={() => saveAsDraft()}
					/>
				)}
				<Button
					type="button"
					button="Save and Continue"
					disabled={!hasPermission(permission, user?.role?.role_permissions)}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => SaveAsContinue()}
				/>
			</div>
		</Modal>
	);
}
